import { ApiActionType } from 'modules/listing/api/volop/types/ApiActionType';

export const ACTION_TYPE_MAP_TITLE: Record<ApiActionType, string> = {
  VOLOP:
    /* TRANSLATORS: "Volunteer +" type */
    getText('Volunteer Opportunity'),
  LOAN:
    /* TRANSLATORS: "Volunteer +" type */
    getText('Loan'),
  DONATION:
    /* TRANSLATORS: "Volunteer +" type */
    getText('Donation'),
  OTHER:
    /* TRANSLATORS: "Volunteer +" type */
    getText('Other Opportunity'),
  PETITION:
    /* TRANSLATORS: "Volunteer +" type */
    getText('Petition'),
};
